var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 173,
    height: 87,
    viewBox: "0 0 173 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_12765",
    "data-name": "Rettangolo 12765",
    width: 173,
    height: 87,
    transform: "translate(1226 1632)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23027",
    "data-name": "Raggruppa 23027",
    transform: "translate(-1235 -1639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23017",
    "data-name": "Raggruppa 23017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_245",
    "data-name": "Gruppo di maschere 245",
    transform: "translate(9 7)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1530",
    "data-name": "Ellisse 1530",
    transform: "translate(1240 1641)",
    fill: "#fff",
    stroke: "#e5e5e5",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 72.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 64.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_22296",
    "data-name": "Raggruppa 22296"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1532",
    "data-name": "Ellisse 1532",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1315 1711)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_12767",
    "data-name": "Rettangolo 12767",
    width: 7.409,
    height: 7.409,
    transform: "translate(1316.261 1713.625) rotate(-45)",
    fill: "#b8b8b8"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Stabilizzato",
    transform: "translate(1265.349 1698.355) rotate(-70)",
    fontSize: 9,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25,
    y: 0
  }, "Stabilizzato")), /*#__PURE__*/React.createElement("text", {
    id: "Assente",
    transform: "translate(1321 1661)",
    fontSize: 9,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17,
    y: 0
  }, "Assente")), /*#__PURE__*/React.createElement("text", {
    id: "Monitorato",
    transform: "translate(1376.65 1698.355) rotate(70)",
    fontSize: 9,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24,
    y: 0
  }, "Monitorato")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph5);
export default __webpack_public_path__ + "static/media/graph5.cbc5c89fe1e9a7d710560b9496faf94e.svg";
export { ForwardRef as ReactComponent };